var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"button is-white is-loading",class:_vm.size,attrs:{"disabled":""}})}
var staticRenderFns = []

export { render, staticRenderFns }